export default __webpack_public_path__ + "static/media/Hamburger.4331ada7.svg";